<template>
	<div id="app" class="flex-w flex-ctr">
		<router-view />
		<LoadPending class="load-btn" v-if="loadStatus" />
	</div>
</template>

<script>
	import LoadPending from './components/LoadPending.vue'
	import {
		mapState
	} from 'vuex'

	export default {
		name: 'app',
		components: {
			LoadPending
		},
		computed: {
			...mapState({
				loadStatus: 'loadStatus'
			})
		},
		created () {
			// this.$router.push("/GE_vote");
		}
	}
</script>

<style lang="scss">
	#app {
		font-family: "微软雅黑", "宋体";
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		background-color: #ffffff;
		color: #333;
	}
	.load-btn {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		z-index: 999;
	}
	#app .van-tab {
		font-size: 30px;
		line-height: 44px;
	}
	#app .van-tabs__line {
		width: 52px !important;
	}
	#app .van-tabs--line {
		padding-top: 61px;
		/* height: 60px; */
	}
	#app .van-tabs--line .van-tabs__wrap {
		height: 60px;
	}
	.van-button {
		cursor: pointer;
	}
</style>
